module.exports = "/_next/static/images/71ee97fb4c62525e559f0aa9ce54f83d-hero-desktop.jpg";